import React from 'react';
import * as Question from '../../QuestionsDisabled';

const Visualizer = (props) => {
    const { question, questionIndex, answers, setAnswers, onAnswer, dashWidth, painScaleHeight, svgHeight } = props;

    if (question) {
        switch (question.type) {
            case 'LIST_MULTI':
                return <Question.List.Multi {...props} key={question.id} />
            case 'LIST_SINGLE':
            case 'Boolean':
                return <Question.List.Single {...props} key={question.id} />
            case 'TEMP':
                return <Question.Temp.Default {...props} key={question.id} />
            case 'TEXT':
                return <Question.Text.Default {...props} key={question.id} />
            case 'MOOD':
                return <Question.Mood.Default {...props} key={question.id} />
            case 'MATRIX_MULTI':
                return <Question.Matrix.Multi {...props} key={question.id} />
            case 'HORIZONTAL_SCALE':
                return <Question.Scale.Horizontal {...props} dashWidth={dashWidth ? dashWidth : 20} key={question.id} />
            case 'PAIN_SCALE':
                return <Question.Scale.Pain.Default {...props} height={painScaleHeight ? painScaleHeight : 300} key={question.id} />
            case 'SVG_MULTI':
                return <Question.SvgMap.Default {...props} height={svgHeight ? svgHeight : 500} key={question.id} />
            case 'SVG_SINGLE':
                return <Question.SvgMap.Default {...props} height={svgHeight ? svgHeight : 500} isSingle key={question.id} />
            case 'DATE':
                return <Question.Date.Default {...props} key={question.id} />
            default:
                return <></>;
        }
    } else {
        return <></>
    }
}

export default Visualizer;